module.exports = __webpack_public_path__ + "img/Sending.db6e62d2.svg";